export const colors = {
  white: 'white',
  black: 'black',
  primary: 'rebeccapurple',
};
